import { render, staticRenderFns } from "./BaseSbpIcon.vue?vue&type=template&id=8da24250&scoped=true"
import script from "./BaseSbpIcon.vue?vue&type=script&lang=js"
export * from "./BaseSbpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da24250",
  null
  
)

export default component.exports